import { Box, TextField, Button, Typography, Container, Paper, Divider, Card, CardContent } from '@mui/material';
import { useState } from 'react';
import EmailIcon from '@mui/icons-material/Email';
const ContactUsForm = () => {
    const [form, setForm] = useState({
        firstName: '',
        lastName: '',
        email: '',
        message: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form Submitted:', form);
        // TODO: Add form submission logic (email/API)
    };

    return (
        <>

            <Container sx={{ padding: '10px' }}>
                <Box component={Paper}>



                    <Typography variant="h5" marginLeft={'10px'}>Contact Us</Typography>

                    <form onSubmit={handleSubmit}>
                        <Box sx={{ padding: '10px' }}  >
                            {/* First Name */}
                            <Box >
                                <Typography sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>First Name</Typography>
                            </Box>
                            <Box >
                                <TextField
                                    name="firstName"
                                    fullWidth
                                    value={form.firstName}
                                    onChange={handleChange}
                                    placeholder="Enter your first name"
                                />
                            </Box>

                            {/* Last Name */}
                            <Box  >
                                <Typography sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>Last Name</Typography>
                            </Box>
                            <Box  >
                                <TextField
                                    name="lastName"
                                    fullWidth
                                    value={form.lastName}
                                    onChange={handleChange}
                                    placeholder="Enter your last name"
                                />
                            </Box>

                            {/* Email */}
                            <Box item >
                                <Typography sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>Email</Typography>
                            </Box>
                            <Box item >
                                <TextField
                                    name="email"
                                    type="email"
                                    fullWidth
                                    value={form.email}
                                    onChange={handleChange}
                                    placeholder="Enter your email"
                                />
                            </Box>

                            {/* Message */}
                            <Box item >
                                <Typography sx={{ display: 'flex', alignItems: 'flex-start', pt: 1.5 }}>Message</Typography>
                            </Box>
                            <Box item >
                                <TextField
                                    name="message"
                                    multiline
                                    rows={4}
                                    fullWidth
                                    value={form.message}
                                    onChange={handleChange}
                                    placeholder="Enter your message"
                                />
                            </Box>

                            {/* Submit Button */}

                            <Button type="submit" variant="contained" sx={{ float: 'center', marginTop: '10px' }}>Submit</Button>

                        </Box>
                    </form>
                </Box>

                <Divider textAlign='center'> OR </Divider>
                <Card sx={{ display: 'flex', width: '100' }}>

                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <CardContent sx={{ flex: '1 0 auto' }}>
                            <Typography component="div" variant="h5">
                                Live From Space
                            </Typography>
                            <Typography
                                variant="subtitle1"
                                component="div"
                                sx={{ color: 'text.secondary' }}
                            >
                                Mac Miller
                            </Typography>
                        </CardContent>

                    </Box>

                </Card>
            </Container>
        </>
    );
};

export default ContactUsForm;
